<template>
    <div>
        <div class="card-error">
            <div class="card-type">
                <em class="fal fa-file-search"/>
                <div class="card-shadow"/>
                <div class="image">
                    <img :src="require('./featured_channel.jpeg')" alt=""/>
                </div>
            </div>

            <div class="card-text">
                <span class="oops">
                    Não é possível encontrar a página !
                </span>
                <div>
                    <span>Esta página não existe ou foi removida</span>
                </div>
                <ui-button design="md primary" @click="redirectHome">Voltar para página inicial</ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import { uiButton } from "@/components/ui/buttons"

export default {
    name: 'ui-not-found',

    components: {
        uiButton,
    },

    methods: {
        redirectHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>